export default "__VITE_ASSET__DJUXTlwr__"